export default __webpack_public_path__ + "static/media/create-account-hero.0f97339c.png";